import "./loading.scss";
import template from "./loading.html";
import {Options, Vue} from "vue-class-component";
import {Prop} from "vue-property-decorator";

@Options({
	template,
})
export class Loading extends Vue {
	@Prop({ default: false }) show: any;
}
